var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eLMG2cDahnp1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 400",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "20ef6acdfb2d4546933fc128b42a18b7",
    "export-id": "73db1506491444a994582190ae472bdb",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp12-fill",
    x1: 1125.32,
    y1: 923.669,
    x2: 935.932,
    y2: 1079.368,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp12-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp12-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp13-fill",
    x1: 909.254,
    y1: 911.812,
    x2: 1008.081,
    y2: 911.812,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp13-fill-0",
    offset: "32.5%",
    stopColor: "#d35652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp13-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp15-fill",
    x1: 845.555,
    y1: 877.428,
    x2: 875.619,
    y2: 800.423,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp15-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp15-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp17-fill",
    x1: 859.878,
    y1: 855.452,
    x2: 897.701,
    y2: 818.665,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp17-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp17-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp20-fill",
    x1: 974.145,
    y1: 875.624,
    x2: 1043.71,
    y2: 796.573,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp20-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp20-fill-1",
    offset: "51%",
    stopColor: "#ea8e67"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp20-fill-2",
    offset: "96%",
    stopColor: "#ffdfc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp22-fill",
    x1: 1062.94,
    y1: 821.379,
    x2: 862.477,
    y2: 1056.022,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp22-fill-0",
    offset: "63.9%",
    stopColor: "#ffd3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp22-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp24-fill",
    x1: 1157,
    y1: 883.15,
    x2: 987.986,
    y2: 1053.972,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp24-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp24-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp26-fill",
    x1: 890.464,
    y1: 752.668,
    x2: 1031.481,
    y2: 752.668,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp26-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp26-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp28-fill",
    x1: 985.016,
    y1: 895.924,
    x2: 988.572,
    y2: 908.57,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp28-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp28-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp29-fill",
    x1: 1428.12,
    y1: 1015.53,
    x2: 907.535,
    y2: 1528.934,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp29-fill-0",
    offset: "0.1%",
    stopColor: "#fec045"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp29-fill-1",
    offset: "100%",
    stopColor: "#f47555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp30-fill",
    x1: 1606.56,
    y1: 830.523,
    x2: 975.464,
    y2: 1464.173,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp30-fill-0",
    offset: "42.4%",
    stopColor: "#f37753"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp30-fill-1",
    offset: "99.9%",
    stopColor: "#d85335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp35-fill",
    x1: 964.999,
    y1: 704.64,
    x2: 887.537,
    y2: 724.831,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp35-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp35-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp38-fill",
    x1: 1041.24,
    y1: 806.942,
    x2: 1028.073,
    y2: 858.771,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp38-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp38-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp40-fill",
    x1: 982.036,
    y1: 812.558,
    x2: 1028.147,
    y2: 812.558,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp40-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp40-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp43-fill",
    x1: 984.361,
    y1: 840.557,
    x2: 1017.11,
    y2: 840.557,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp43-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp43-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp53-fill",
    x1: 957.077,
    y1: 919.811,
    x2: 965.245,
    y2: 881.838,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp53-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp53-fill-1",
    offset: "71.2%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp62-fill",
    x1: 950.296,
    y1: 796.652,
    x2: 958.46,
    y2: 839.284,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp62-fill-0",
    offset: "23.2%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp62-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp64-fill",
    x1: 950.078,
    y1: 813.028,
    x2: 903.967,
    y2: 813.028,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp64-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp64-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp67-fill",
    x1: 947.753,
    y1: 841.027,
    x2: 915.004,
    y2: 841.027,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp67-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp67-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp75-fill",
    x1: 876.225,
    y1: 902.002,
    x2: 1014.977,
    y2: 1005.72,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp75-fill-0",
    offset: "0%",
    stopColor: "#010019"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp75-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp76-fill",
    x1: 1036.59,
    y1: 979.347,
    x2: 979.941,
    y2: 1049.746,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp76-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp76-fill-1",
    offset: "92.1%",
    stopColor: "#f05960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp79-fill",
    x1: 1234.72,
    y1: 1014.11,
    x2: 873.076,
    y2: 1219.067,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp79-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp79-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp80-fill",
    x1: 655.763,
    y1: 1407.05,
    x2: 950.955,
    y2: 1137.628,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp80-fill-0",
    offset: "0.5%",
    stopColor: "#aeaeba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp80-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp82-fill",
    x1: 1097.82,
    y1: 1210.06,
    x2: 813.959,
    y2: 1388.639,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp82-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp82-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp82-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp83-fill",
    x1: 625.411,
    y1: 1373.46,
    x2: 1415.617,
    y2: 800.111,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp83-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp83-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp83-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp86-fill",
    x1: 596.682,
    y1: 1432.39,
    x2: 796.865,
    y2: 1193.674,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp86-fill-0",
    offset: "0.5%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp86-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp87-fill",
    x1: 623.03,
    y1: 1490.47,
    x2: 826.173,
    y2: 1248.224,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp87-fill-0",
    offset: "0.5%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp87-fill-1",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp88-fill",
    x1: 928.232,
    y1: 1486.04,
    x2: 1117.445,
    y2: 880.136,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp88-fill-0",
    offset: "17.4%",
    stopColor: "#a58ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp88-fill-1",
    offset: "35.8%",
    stopColor: "#ccc4cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp88-fill-2",
    offset: "99.9%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp90-fill",
    x1: 734.224,
    y1: 1757.51,
    x2: 1277.054,
    y2: 1371.642,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp90-fill-0",
    offset: "6.8%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp90-fill-1",
    offset: "46.3%",
    stopColor: "#e8e8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp90-fill-2",
    offset: "62.3%",
    stopColor: "#f2d6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp90-fill-3",
    offset: "86.3%",
    stopColor: "#ffba9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eLMG2cDahnp100-fill",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp100-fill-0",
    offset: "0%",
    stopColor: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eLMG2cDahnp100-fill-1",
    offset: "100%",
    stopColor: "#010022"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.439253 0 0 0.43799-16.74512-76.8281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.6392-159.641)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.698626 0 0 0.783404-372.978-24.8797)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631,1120.7q-.2,0-.4-.1-.2,0-.4-.2c-.2-.2-.3-.5-.3-.8c0-.4.1-.7.3-.9l10.1-10.1l10.1-10.1c.3-.2.6-.4.9-.4s.6.2.8.4.3.5.3.8-.1.6-.3.9L642,1110.3l-10.1,10.1q-.2.2-.4.2-.2.1-.5.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.3,1120.7q-.3,0-.5-.1-.2,0-.4-.2l-10.1-10.1-10.1-10.1c-.2-.3-.3-.6-.3-.9s.1-.6.3-.8.5-.4.8-.4.6.2.9.4l10.1,10.1l10.1,10.1c.2.2.3.5.3.9c0,.3-.1.6-.3.8q-.2.2-.4.2-.2.1-.4.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1333.4,1063.6q-.2,0-.4-.1t-.4-.3c-.2-.2-.4-.5-.4-.8s.2-.6.4-.8l10.1-10.1l10.1-10.1c.2-.3.5-.4.8-.4s.6.1.9.4c.2.2.3.5.3.8s-.1.6-.3.8l-10.1,10.1-10.1,10.1q-.2.2-.4.3t-.5.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.6,1063.6q-.2,0-.4-.1t-.4-.3l-10.1-10.1-10.1-10.1c-.2-.2-.4-.5-.4-.8s.2-.6.4-.8c.2-.3.5-.4.8-.4s.6.1.9.4l10.1,10.1l10.1,10.1c.2.2.3.5.3.8s-.1.6-.3.8q-.2.2-.4.3t-.5.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eLMG2cDahnp11",
    transform: "matrix(1.20804 0 0 1.22679 600-239.052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1025.8,986.4c.1,1.3-.8,3.1-2,4.8s-2.6,3.3-3.5,4.3c-2.8,3.3-6.6,6.3-10.7,8.9-4.1,2.5-8.4,4.7-12.3,6.5-4.1,1.8-8.3,3.3-12.6,4.5s-8.7,2-13.1,2.5c-5.1.6-10.3.7-15.4.2s-10.2-1.6-15.2-3.3c-5-1.8-10-4.3-14.7-7.2-4.8-2.9-9.4-6-13.8-9.2q-2.7-1.8-5.2-3.5-2.6-1.8-5-3.3q1.5-1.2,2.8-2.4q1.4-1.2,2.5-2.5.5-.5.9-.9t.8-.8q2.1-2.3,3.9-4.8q1.9-2.6,3.4-5.2c3.6-6.3,6.2-13.2,7.6-20.5c1.4-7.2,1.8-14.7,1.1-22.2-.2-2.1-1.1-5.6-1.8-9-.6-3.5-1-6.8,0-8.6c11.3,1.5,22.7,2.7,34.2,2.9c11.4.3,22.9-.4,34.1-2.6q3.7-.7,7.4-1.4q3.6-.8,7.3-1.8c.1,2.6,0,5.3,0,7.9s0,5.3.4,7.8q.3,1.5.6,3.1.3,1.5.6,3q.6,2.8,1.1,5.5.6,2.8,1,5.6c1,5.9,2.6,11.6,4.5,17.1c1.9,5.6,4.1,11,6.4,16.5.5,1.1,1.6,2.6,2.6,4.1s1.9,3,2.1,4Z",
    fill: "url(#eLMG2cDahnp12-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.1,933.6c-1.7,2.5-4,4.9-6.4,7-2.3,2.2-4.7,4.2-6.6,5.8-5.6,4.8-11.7,9.3-18,13.4s-12.9,7.7-19.6,10.8q-4.7,2.1-9.4,3.9-4.8,1.7-9.6,3.3c-1.6.5-6,1.9-10,3.2s-7.5,2.5-7.5,2.5c1.3,4.4,3.4,8.7,6.1,12.4s6.1,6.9,10.1,9.2c-2.7-.2-5.3-.9-7.8-2-2.5-1-4.8-2.5-6.9-4.2-2-1.8-3.8-3.9-5.2-6.2s-2.5-4.8-3.2-7.4c-.2-1-1.1-1.2-2.1-1-.9.1-2,.5-2.7.7c6.3-6.9,10.8-15.3,13.4-24.4c2.7-9,3.5-18.7,2.6-28.3-.2-2.1-1.1-5.6-1.8-9-.6-3.5-1-6.8,0-8.6c11.3,1.5,22.7,2.7,34.2,2.9c11.4.3,22.9-.4,34.1-2.6q3.7-.7,7.4-1.4q3.6-.8,7.3-1.8c.1,2.6,0,5.3,0,7.9s0,5.3.4,7.8q.3,1.5.6,3.1.3,1.5.6,3Z",
    fill: "url(#eLMG2cDahnp13-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M904.2,846.4q-.1-.1-.2-.3-.1-.1-.2-.3-1.1-1.3-2.3-2.5t-2.4-2.4q-1.1-1.1-2.3-2.2t-2.5-2q-2.7-2-5.7-3.3t-6.3-1.7c-4.8-.5-8.6,1.5-11.2,4.7s-4,7.7-4.1,12c-.4,7.9,4.6,16.9,11.7,22.8c7,5.9,16.2,8.7,24.3,4.1q1.6-.9,2.8-2.2t2-3c.9-1.8,1.4-3.7,1.6-5.6.2-2,.1-4-.1-5.9-.3-2.2-.9-4.4-1.7-6.4-.9-2.1-2-4-3.4-5.8Z",
    fill: "url(#eLMG2cDahnp15-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.1,866.6c-.9.3-2.1.3-3.3.2-1.2-.2-2.4-.6-3.2-.8q-1.6-.5-3-1.4-1.5-.8-2.7-1.9c-1.3-1.1-2.5-2.8-3.4-4.6-.9-1.9-1.5-3.9-1.6-5.9q-.1-1.4.2-2.7t1-2.5c.7-.9,1.6-1.8,2.6-2.5c1.1-.8,2.2-1.4,3.3-1.7c2.2-.6,4.2-.6,6,0s3.5,1.7,5.1,3.3q.8.9,1.5,1.8t1.3,1.8q.1.1.2.3t.2.4q.2.3.4.7.3.4.5.7c-.9-.9-1.9-1.8-3.1-2.5-1.2-.6-2.5-.9-3.7-.8q-.9.1-1.8.6-.9.4-1.7,1.3c-1.4,1.6-1.9,3.7-1.7,5.8s1,4.2,2,5.8c.7,1,1.4,1.9,2.2,2.6s1.6,1.4,2.7,2Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876,839.8c0-3.8,2.5-5.8,5.6-6.5c3.1-.6,6.9.1,9.3,1.8.7.5,1.4,1,2.1,1.6.7.5,1.3,1.1,1.8,1.8s.9,1.5.9,2.3c.1.8-.2,1.5-1.2,1.9-.7.3-1.5.3-2.4.2-.9-.2-1.8-.3-2.6-.3q-1.4.1-2.8.4-1.5.2-2.8.6c-.9.2-1.7.3-2.5.3s-1.6-.1-2.5-.5c-.7-.4-1.5-.9-2.1-1.5-.6-.7-1-1.4-.8-2.1Z",
    fill: "url(#eLMG2cDahnp17-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.2,851.8c-.9-.9-1.9-1.8-3.1-2.5-1.2-.6-2.5-.9-3.7-.8-1-.4-2.2,0-3.2.7s-1.9,1.7-2.4,2.5c-.7.9-1.1,2.1-1.4,3.3s-.3,2.5-.1,3.7c.1.8.4,2.1.8,3.3.5,1.2,1.2,2.3,2.2,2.7-1.7-.4-3.3-1.4-4.7-2.6s-2.6-2.7-3.5-4.1c-.7-1.2-1.1-2.5-1.3-3.9s-.1-2.8.2-4.2c.4-1.6,1.2-2.9,2.4-3.9c1.1-1,2.6-1.6,4.3-1.8c2.4-.3,4.7.1,6.8,1.1c2,1,3.9,2.6,5.4,4.4q.1.1.2.3t.2.4q.2.3.4.7.3.4.5.7Z",
    fill: "#b22842"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1021.6,846.4q.1-.1.2-.3.1-.1.3-.3q1-1.3,2.2-2.5t2.4-2.4q1.2-1.1,2.4-2.2t2.5-2q2.6-2,5.6-3.3t6.3-1.7c4.9-.5,8.6,1.5,11.2,4.7s4,7.7,4.2,12c.3,7.9-4.7,16.9-11.7,22.8-7.1,5.9-16.3,8.7-24.4,4.1q-1.6-.9-2.8-2.2t-2-3c-.8-1.8-1.3-3.7-1.5-5.6-.2-2-.2-4,.1-5.9.2-2.2.8-4.4,1.7-6.4.8-2.1,2-4,3.3-5.8Z",
    fill: "url(#eLMG2cDahnp20-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.6,868.4c.9.4,2.1.3,3.3.2c1.2-.2,2.4-.5,3.2-.8q1.5-.5,3-1.3q1.4-.8,2.6-2c1.4-1.1,2.6-2.8,3.5-4.6.9-1.9,1.5-3.9,1.6-5.9q.1-1.4-.2-2.7t-1.1-2.4c-.6-1-1.5-1.9-2.6-2.6-1-.8-2.2-1.3-3.2-1.7-2.2-.6-4.2-.6-6,0-1.9.6-3.6,1.8-5.1,3.3q-.9.9-1.6,1.8-.6.9-1.2,1.8-.1.1-.2.3-.2.2-.2.4-.3.3-.5.7t-.4.8c.8-1,1.9-1.9,3.1-2.5s2.4-1,3.7-.9q.9.2,1.8.6t1.7,1.3c1.4,1.6,1.8,3.7,1.7,5.8-.2,2.1-1,4.2-2.1,5.8-.6,1.1-1.3,1.9-2.1,2.6s-1.7,1.4-2.7,2Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.8,840.6c0-3.8-2.5-5.8-5.6-6.5-3.1-.6-6.8.1-9.2,1.8-.7.5-1.5,1-2.2,1.6-.7.5-1.3,1.1-1.8,1.9-.4.6-.8,1.4-.9,2.2c0,.8.3,1.5,1.2,1.9.7.3,1.6.3,2.5.2s1.8-.3,2.5-.3q1.5.1,2.9.4q1.4.2,2.8.6c.9.2,1.7.4,2.5.3.8,0,1.6-.1,2.5-.5.7-.4,1.5-.9,2.1-1.5.5-.7.9-1.4.7-2.1Z",
    fill: "url(#eLMG2cDahnp22-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.5,853.7c.8-1,1.9-1.9,3.1-2.5s2.4-1,3.7-.9c1-.4,2.1,0,3.2.7c1,.7,1.9,1.7,2.4,2.5.6,1,1.1,2.1,1.4,3.3s.3,2.5.1,3.7c-.1.8-.4,2.1-.9,3.3-.4,1.3-1.1,2.4-2.1,2.7c1.7-.4,3.3-1.4,4.7-2.6s2.6-2.6,3.5-4.1c.7-1.2,1.1-2.5,1.3-3.9.1-1.4.1-2.8-.3-4.1-.3-1.7-1.1-3-2.3-4s-2.6-1.6-4.3-1.8c-2.4-.3-4.7.2-6.8,1.1-2.1,1-3.9,2.6-5.4,4.4q-.1.1-.2.3-.2.2-.2.4-.3.3-.5.7t-.4.8Z",
    fill: "#b22842"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1032.2,802.1c0,9.5,0,17.5-.3,25.5s-.8,15.9-1.8,25.2c-.5,4.5-.9,10.1-1.4,15.9-.4,5.8-1,11.8-1.8,17.2-.6,4.2-.9,8.5-1.6,12.4-.8,4-2,7.7-4.4,10.5-3,3.4-5.5,7.1-8.2,10.6-2.6,3.6-5.3,7.2-8.5,10.4-2.3,2.3-4.9,4.9-7.8,7.3-2.8,2.4-5.9,4.6-9.1,6.1q-1.1.5-2.2.8-1,.4-2.2.7c-3.1.6-6.2,1-9.4,1.3-3.1.3-6.2.5-9.5.7-2.2.1-4.8-.2-7.4-.6s-5.2-1.1-7.4-1.7c-1.2-.3-3.1-1-5.1-1.9-1.9-.8-3.9-1.8-5.4-2.9-3.7-2.7-7-5.4-10.4-8.4-3.4-3.1-6.8-6.5-10.7-10.7-2.6-2.8-5.4-4.9-7.8-7.2-2.4-2.4-4.3-5-5.2-8.9-.7-3.5-1.3-6.8-1.9-10.2-.5-3.3-1-6.7-1.6-10.3-.5-3.6-1-7-1.4-10.4s-.8-6.8-1.1-10.5c-.8-7.3-1.9-15.5-2.9-23.7s-1.9-16.4-2.2-23.7q-.3-5.5-.6-11.1-.2-5.5-.5-11c-.2-3.5,0-7.3,0-11.1-.1-3.7-.4-7.4-1.5-10.5s0-5.1,1.9-6.5c2-1.4,4.8-2.2,7.1-2.9c9.4-3,19.5-5,29.7-6.4s20.5-2.3,30.3-2.9q11.8-.7,23.6-.5t23.6,1.3c3.3.3,6.8.6,10.2,1.2c3.4.7,6.8,1.7,9.6,3.5c2.2,1.3,3.3,2.9,3.8,4.6.6,1.8.7,3.9.8,6.3v.1c.2,5.4.4,10.8.5,16.2.2,5.3.2,10.7.2,16.2Z",
    fill: "url(#eLMG2cDahnp24-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031.5,769.6v.1c-1.3.3-2.8.5-4.3.8-1.5.4-2.9.8-3.8,1.4-.8.4-2.1.4-3.5.3s-2.8-.3-3.9-.3q-3.2.1-6.3.4-3.2.2-6.3.4c-5.3.2-10.5.3-15.6.7-5.2.3-10.4.8-15.6,1.7-5.7,1.1-11.5,2.3-17.2,3.7-5.8,1.3-11.5,2.7-17.1,4.1-4,1-7.5,2.3-10.9,3.7s-6.8,3.1-10.4,5c-3.2,1.6-4.7,4.2-5.5,7.2-.7,3-.8,6.3-1.1,9.4q-.4,4.9-.6,9.9-.2,4.9-.1,9.8c0,7.3,0,14.7.3,22.1.4,7.3,1.1,14.6,2.5,21.7c2.7,14,7.4,27.8,15.1,39.7c7.6,12,18.1,22,32.5,28.2c4.2,1.7,8.4,3,13,3.6c4.5.6,9.3.6,14.6,0q-1.1.5-2.2.8-1,.4-2.2.7c-3.1.6-6.2,1.1-9.4,1.5-3.1.3-6.2.4-9.5.5-3.4,0-5.9-.2-8.2-.6-2.2-.3-4.2-.9-6.6-1.7-1.7-.5-3.4-1.1-5.1-1.8s-3.3-1.5-4.7-2.5c-3.7-2.7-7.2-5.5-10.8-8.7-3.5-3.1-7.1-6.7-11-10.9-2.6-2.8-5.4-4.9-7.8-7.2-2.4-2.4-4.3-5-5.2-8.9-.7-3.5-1.3-6.8-1.9-10.2-.5-3.3-1-6.7-1.6-10.3-.5-3.6-1-7-1.4-10.4s-.8-6.8-1.1-10.5c-.8-7.3-1.9-15.5-2.9-23.7s-1.9-16.4-2.2-23.7q-.3-5.5-.6-11.1-.2-5.5-.5-11c-.2-3.5,0-7.3,0-11.1-.1-3.7-.4-7.4-1.5-10.5s0-5.1,1.9-6.5c2-1.4,4.8-2.2,7.1-2.9c9.4-3,19.5-5,29.7-6.4s20.5-2.3,30.3-2.9q11.8-.7,23.6-.5t23.6,1.3c3.3.3,6.8.6,10.2,1.2c3.4.7,6.8,1.7,9.6,3.5c2.2,1.3,3.3,2.9,3.8,4.6.6,1.8.7,3.9.8,6.3Z",
    fill: "url(#eLMG2cDahnp26-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1029.6,807.7q-.1-.4-.1-.8-.1-.4-.1-.8q0-.3,0-.6-.1-.3-.1-.6-.5-6.2-.9-12.3-.5-6.1-.9-12.2-2,.2-4.1.4-2.1.3-4.1.6.3-3,.7-6q.3-3,.7-6c-4.9-1.5-10.1-2.4-15.2-2.8-5.2-.5-10.4-.6-15.5-.6-10.8,0-21.6.5-32.3,1.7-10.7,1.1-21.3,2.8-31.8,5.2q-3.7.8-7.4,1.8t-7.3,2.3q-2.4.8-4.8,1.6-2.4.7-4.9,1.5.7,2.6,1.3,5.1.5,2.6.9,5.2c-.3.2-1.8.5-3.2.8-1.4.2-2.7.4-2.7.5q-.8,10.6-1.2,21.2-.3,10.6-.3,21.2c0,1.7,0,4.5,0,7c.1,2.5.1,4.5.1,4.5-.4-3.6-.9-7.3-1.4-11s-1.1-7.5-1.5-11.4q-.7-6.9-1.2-13.4-.6-6.5-1.2-12.6c-.2-2.3-.2-4.7-.4-7.1-.1-2.4-.4-4.8-1.1-6.9-3.5,2.3-6.7,5.5-9.4,9-2.7,3.6-4.9,7.6-6.1,11.5-.6-2.5-.8-5.2-.7-7.9s.4-5.4.9-7.9c.6-4,1.7-7.9,3.1-11.6c1.4-3.8,3.1-7.4,5.1-10.9q1.6-2.6,3.3-5q1.8-2.5,3.8-4.7q1-1.2,2-2.3q1.1-1,2.2-2.1c.3-.3,1.2-1.2,2.1-2c.9-.9,1.8-1.6,2.2-1.5-2-.5-4.3-.8-6.6-1-2.3-.1-4.6-.2-6.7,0q-3.4.1-6.8.4-3.4.2-6.8.7c1.5-3.4,4-6.5,6.7-9.3c2.7-2.9,5.8-5.5,8.6-7.8q4.5-3.9,9.5-7.2t10.3-6c3.6-1.9,7.3-3.7,11.1-5.1s7.7-2.6,11.8-3.2c6.4-1.1,12.9-1.8,19.4-1.8s13,.7,19.2,2.2c3.9,1,7.6,2.3,11.3,3.8c3.6,1.6,7.2,3.4,10.6,5.3q2.6,1.5,5.1,3.1q2.5,1.5,5,3.2c.8.5,2.9,2.6,4.8,4.6c1.8,1.9,3.5,3.7,3.5,3.7s1-.6,2.2-1.3c1.1-.8,2.4-1.7,2.9-2.2c1.1-1.2,2.3-2.6,3.3-3.9.9-1.3,1.8-2.5,2.3-3.4.9-1.5,1.4-3,1.7-4.4.4-1.5.6-3,1-4.8c1.2,2.1,1.9,4.7,2.2,7.3.2,2.6,0,5.3-.7,7.5s-1.6,3.8-2.7,5.3c-1.2,1.4-2.6,2.6-4.2,3.9c4.2-2.6,9.5-1.6,14.3.9s9.2,6.3,11.7,9.4c-3.5-.9-6.6-1.3-9.7-1.2s-6.2.6-9.7,1.2c2.2.3,4.3,1.5,6.2,3s3.6,3.4,5,5c1.5,1.6,2.8,3.7,3.8,5.9c1,2.3,1.7,4.6,1.8,6.5-1.1,1.5-1.8,3.2-2.3,5.1-.4,1.9-.7,3.9-1.1,5.7-.4,2.2-.6,4.4-.8,6.7-.2,2.2-.3,4.5-.4,6.7q-.4,7.1-1,14.2t-1.2,14.2c-.2,2.4-.5,6.1-.8,9.2-.2,3.1-.4,5.6-.4,5.6q0-1.8,0-3.6-.1-1.8-.1-3.6c0-1.8-.2-3.6-.4-5.4-.2-1.9-.4-3.7-.6-5.5q-.2-2.4-.4-4.8-.2-2.5-.4-4.9Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.4,909.6c0,0,.9,0,2.3-.1c1.4-.2,3.3-.5,5.2-1.1q1.1-.4,2-.8q1-.5,1.9-1.2c.4-.3,1.2-1.2,2-2.1.7-.9,1.5-2,1.8-2.6-.1.2-.2.7-.3,1.3-.2.6-.5,1.3-.8,2-.4.7-.9,1.4-1.4,2.1-.5.6-1.1,1.2-1.8,1.6-.6.4-1.7,1-3.4,1.3s-4.1.3-7.5-.4Z",
    fill: "url(#eLMG2cDahnp28-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.2,1290.4c-4.3,6.6-13.7,16-22.4,23.9-8.8,7.8-16.9,14.1-18.6,14.2-9.1.8-18,.8-27,.5-8.9-.2-17.8-.6-26.9-.6q-14.7.2-29.3.2-14.6.1-29.2.2-30.5.1-61,0-30.5,0-61-.2-15.3-.1-30.5-.3-15.3-.1-30.5-.3-7.6,0-15.2-.1-7.7-.1-15.3-.2c-4.5-.1-9,.4-13.1.1-4.1-.4-7.9-1.6-11-5.1-5.9-6.7-10.7-13.8-15.2-21.2-4.5-7.5-8.6-15.1-13-22.8-3.9-7-5.3-14.7-5.5-22.5-.2-7.9.9-15.8,2.1-23.3c1.4-9.1,2.7-18.1,4.2-27.1c1.4-9,3-18,4.7-27c3.6-17.7,7.6-35.3,12.2-52.8c4.5-17.4,9.5-34.8,15-52c1.6-4.9,3.3-10,5.2-15c2-5,4.1-9.9,6.5-14.5c2-3.9,3.9-7.9,6.2-11.5s5.1-6.8,9-8.9c15.8-8.4,31.5-16,47.4-23.3c15.8-7.3,31.7-14.3,47.9-21.6-1.5,5-.7,9.6,1.5,13.8c2.3,4.1,5.8,7.7,9.7,10.8c6.8,5.3,16.1,9.5,25.9,11.9c9.7,2.4,19.9,3.2,28.4,1.9c5.2-.8,9.9-2.5,14.4-4.8c4.5-2.2,8.8-4.9,13.2-7.6c4.5-2.8,9.7-6.3,14.4-10.3s9-8.4,11.7-13c2.2.8,4.5,1.6,6.9,2.4c2.5.9,5,1.7,7.6,2.5c3.1,1.1,6.3,2.1,9.4,3.2c3,1.1,5.9,2.1,8.4,3.2c9.4,4.1,16.7,7.3,23.7,10.7c6.9,3.3,13.7,6.7,21.9,11.2c5.7,3.2,10.6,6,14.6,9.2c4,3.3,7.1,6.8,9,11.4c1.7,4.1,3.5,8.3,5.2,12.5c1.8,4.2,3.5,8.4,5.2,12.6c7.5,19.2,13.3,39.2,18.1,59.4c4.8,20.3,8.6,40.8,12.1,61c1.8,9.9,3.5,20.7,4.9,31.6c1.4,10.8,2.5,21.7,3,31.8q0,.2,0,.4t.1.4c.3,8.2,1.4,16,1.2,23.4-.2,7.5-1.6,14.6-6.2,21.6Z",
    fill: "url(#eLMG2cDahnp29-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.2,1290.4c-4.3,6.6-13.7,16-22.4,23.9-8.8,7.8-16.9,14.1-18.6,14.2-9.1.8-18,.8-27,.5-8.9-.2-17.8-.6-26.9-.6q-14.7.2-29.3.2-14.6.1-29.2.2-30.5.1-61,0-30.5,0-61-.2-15.3-.1-30.5-.3-15.3-.1-30.5-.3-7.6,0-15.2-.1-7.7-.1-15.3-.2c-4.5-.1-9,.4-13.1.1-4.1-.4-7.9-1.6-11-5.1-5.9-6.7-10.7-13.8-15.2-21.2-4.5-7.5-8.6-15.1-13-22.8-3.9-7-5.3-14.7-5.5-22.5-.2-7.9.9-15.8,2.1-23.3c1.4-9.1,2.7-18.1,4.2-27.1c1.4-9,3-18,4.7-27c3.6-17.7,7.6-35.3,12.2-52.8c4.5-17.4,9.5-34.8,15-52c1.6-4.9,3.3-10,5.2-15c2-5,4.1-9.9,6.5-14.5c2-3.9,3.9-7.9,6.2-11.5s5.1-6.8,9-8.9c9.7-5.2,19.3-10,28.7-14.7c9.5-4.6,18.9-9,28.4-13.4q9-4.1,18.1-8.3q9.1-4.1,18.4-8.3c-1.5,5-.2,9.6,2.4,13.7s6.6,7.6,10.5,10.7c6.8,5.3,16.1,9.5,25.9,11.9c9.7,2.4,19.9,3.2,28.4,1.9c5.2-.8,9.9-2.5,14.4-4.8c4.5-2.2,8.8-4.9,13.2-7.6c4.5-2.8,9.7-6.3,14.4-10.3s9-8.4,11.7-13q2.1.8,4.4,1.6t4.7,1.6q1.3.4,2.7.9q1.3.4,2.7.8c-2.4,6.2-4.7,11.6-7.6,16.6-2.9,5.1-6.5,9.9-11.3,14.9-5.6,5.6-11.5,10.6-17.6,15.4-6,4.8-12.3,9.3-18.7,13.9-10.5,7.4-22.7,13.5-35.3,18.6-12.7,5.1-25.7,9.1-38,12.4-6,1.6-12.1,3.3-18.3,4.8-6.1,1.5-12.3,2.8-18.3,3.4-3.9,32.9,1.6,68.1,14.1,100.8c12.4,32.7,31.7,62.9,55.4,85.8c2.7,2.6,6.7,7.6,11.1,12c4.4,4.3,9.1,8,13.2,8c1.2.1,2.5-.2,3.6-.6c1.2-.5,2.3-1,3.5-1.6c15.7-8.3,30.4-18.6,43.7-30.5s25.2-25.4,35.3-40c10.7-15.6,19-31.2,24.6-47.8s8.5-34,8.2-53.2c5.3,8.2,10.3,18.8,14.4,29.7s7.4,22.1,9.3,31.8c2.6,13.4,4.3,26.2,5.2,38.6.8,12.5.7,24.5-.5,36.4-.5,4.8-.6,7.5-.8,10.1-.3,2.5-.7,5.1-1.9,9.8c4.9.8,10.1,1.4,15.2,1.2c5.1-.3,10.1-1.3,14.7-3.5c6.2-3.1,12.1-7.5,17.5-12.5c5.4-4.9,10.4-10.5,14.9-15.9.3,8.2,1.4,16,1.2,23.4-.2,7.5-1.6,14.6-6.2,21.6Z",
    fill: "url(#eLMG2cDahnp30-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.2,985.1c-.2,2.6-1.5,5.3-3,8-1.5,2.6-3.3,5.2-4.6,7.2-2,3.2-4.1,6.3-6.5,9.2s-5,5.5-8,7.9c-7.7,6.3-16.5,10.6-25.8,13.5s-19.2,4.5-28.9,5.5c-6.8.6-13.3.7-19.7.1-6.4-.7-12.7-2.2-19-4.9-8.1-3.4-16.2-7.4-23.8-12.2-7.6-4.7-14.8-10.2-20.9-16.6q-1.5-1.5-3.1-3.2-1.6-1.8-3.2-3.6q9-4.1,18.1-8.3q9.1-4.1,18.4-8.3c-1.5,5-.2,9.6,2.4,13.7s6.6,7.6,10.5,10.7c6.8,5.3,16.1,9.5,25.9,11.9c9.7,2.4,19.9,3.2,28.4,1.9c5.2-.8,9.9-2.5,14.4-4.8c4.5-2.2,8.8-4.9,13.2-7.6c4.5-2.8,9.7-6.3,14.4-10.3s9-8.4,11.7-13q2.1.8,4.4,1.6t4.7,1.6Z",
    fill: "#c6402a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841,1120.6c-6.8,12.1-11.9,25.2-15.2,38.7s-4.8,27.4-4.3,41.3c.4,13.9,2.8,27.7,7,41c4.1,13.2,10.1,25.9,17.6,37.6-.1-.3-.2-.7-.2-1-.1-.4-.1-.8-.2-1.1-2-9.7-3.9-19.4-5.4-29.2-1.6-9.7-2.8-19.6-3.3-29.4-.6-10.5-1-20.9-1.1-31.4-.2-10.5,0-20.9.7-31.4q.6-8.8,1.6-17.6q1.1-8.8,2.8-17.5Z",
    fill: "#c6402a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.8,988.6c-2.8,7.3-6.9,13.6-11.9,19-5.1,5.5-11.1,10.1-17.8,14.2-10.1,6.1-21.8,9.2-32.8,10.5-11.1,1.2-21.5.5-29.1-1.1-4.6-.9-9.4-2.4-14-4.3-4.5-1.9-8.9-4.3-12.7-7-3-2.1-5.8-4.5-8.2-6.9s-4.4-4.7-5.8-6.7c-1-1.4-2.5-3.6-3.8-5.9-1.4-2.3-2.7-4.7-3.3-6.4-.1-.3-.9-2.2-1.6-4.1-.7-1.8-1.4-3.6-1.2-3.7q2.3-1.8,4.7-3q2.3-1.3,4.4-2c1.5-.6,3.1-1.2,4.8-1.8s3.5-1,5.2-1.3c.4,2.8,1.3,5.5,2.4,8.1c1.1,2.5,2.5,4.9,4.2,7.1q1.7,2.2,3.7,4t4.3,3.2c3.8,2.4,7.7,4.1,11.8,5.4s8.4,2.2,12.8,2.8c4.5.7,9.1,1.2,13.6,1.2c4.6,0,9.2-.3,13.7-1.3c4.9-1,9.7-2.7,14.2-4.9c4.5-2.3,8.7-5.1,12.6-8.3c1.9-1.6,3.6-3.4,5.1-5.4c1.5-2.1,2.7-4.3,3.5-6.6.6-1.7,1.3-3.7,1.8-5.7.4-2.1.6-4.1.1-5.9.6.2,1.6.5,2.6.9c1.1.3,2.1.7,2.7,1c2.8,1.4,4.7,2.5,6.4,3.7c1.7,1.1,3.2,2.4,5.1,4c.4.3,1.1.8,1.8,1.2.7.5,1.4,1.1,1.8,1.6q0,0,0,.1t0,.2c.2.5,0,1.2-.3,2s-.6,1.6-.8,2.1Z",
    fill: "#f05960"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M967.7,715.5q.3.4.3.9t-.4,1.2c-.4.8-.8,1.6-1.3,2.4s-1,1.6-1.7,2.2c-1.2,1.3-2.5,2.3-3.9,3.3s-2.9,1.9-4.4,2.8c-.7.4-1.4.8-2.1,1.2-.7.3-1.5.6-2.3.7-.7,0-1.3-.1-2-.2s-1.3-.3-2-.4c-3-.6-6-1.1-9.1-1.5-3-.4-6-.7-9.1-.8-3-.1-6.1,0-9.1.5-3,.4-6,1.2-8.8,2.4c4.6-1.1,9.4-1.4,14.1-1c4.7.3,9.4,1.4,13.7,3.2q.6.2,1,.5.5.3.8.8c1,1.5-.6,2.6-2.6,3.4-2,.7-4.5,1.1-5.3,1.2-1.9.1-3.7,0-5.6-.2-1.8-.2-3.7-.4-5.5-.6-5.3-.5-10.5-.9-15.8-.9-5.2.1-10.4.4-15.6,1.4.3-.1.7-.4,1.2-.7.4-.4.8-.7,1.1-.9q.8-.5,1.6-.9.8-.5,1.5-1q1.6-.8,3.1-1.6q1.6-.8,3.2-1.6c3.6-1.5,7.2-3,10.8-4.3c3.7-1.4,7.4-2.6,11.1-3.6-2.5,0-5.1.3-7.6.8-2.5.4-5,1-7.5,1.7q-1.8.5-3.7,1-1.9.6-3.7,1.2-.5.2-1,.3-.4.2-.9.3c-.2.1-.5.3-.8.4-.4.1-.7.2-.9.2-.5,0-.5-.3-.3-.5.1-.3.5-.6.7-.8q.7-.6,1.4-1.2t1.5-1.2q1.5-1.1,3.1-2q1.6-1,3.3-1.8q1.9-1,3.9-1.8q2-.9,4-1.7c4.1-1.6,8.2-3,12.4-4.2c4.2-1.1,8.4-1.8,12.9-2.1q6.2-.3,12.3.3q6.2.6,12.1,2.2.7.2,1.2.4.5.3.7.6Z",
    fill: "url(#eLMG2cDahnp35-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M983.4,829.9c-.3,2.4-.6,4.8-.9,7.1-.2,2.4-.4,4.8-.3,7.3c0,2.1.1,4.6.6,7c.4,2.4,1.1,4.7,2.4,6.4c2.5,3.5,6.6,4.8,11,4.9c4.4,0,9-1.2,12.4-2.6c4.2-1.7,7.6-5.4,10.3-9.6c2.6-4.3,4.5-9.2,5.7-13.4.5-2,1-4.4,1.1-6.8.2-2.4,0-4.8-.7-6.8-1-2.7-2.9-4.2-5.3-5-2.3-.7-5-.8-7.4-.7-4.6.2-9.9.9-14.8,2.6-5,1.6-9.5,4.1-12.9,7.8q-.4.5-.7,1t-.5.8Z",
    fill: "url(#eLMG2cDahnp38-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1017.3,850.5c-.1,1.5-.4,3-.9,4.4s-1.2,2.7-2.2,3.9c-1.1,1.1-2.4,1.9-3.9,2.6-1.4.6-3,1.1-4.5,1.5q-2.5.5-5,.8-2.6.2-5.1.1-2.9-.2-5.4-1.3-2.4-1.1-4.4-3.1-.3-.4-.6-.7-.2-.4-.4-.7-.7-1.2-.8-2.4-.1-1.3.3-2.6q0-.6.2-1.1.2-.6.4-1.2c.5-1.5,1.4-3.1,2.4-4.6c1.1-1.4,2.3-2.7,3.7-3.6c2.6-1.8,5.4-2.9,8.4-3.5s6.1-.6,9.1-.2c1.1.1,2.3.4,3.3.7c1.1.4,2,1,2.8,1.9q1,1,1.6,2.3t.8,2.7q.2,1,.3,2q0,1.1-.1,2.1Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.2,821.7c-.1.7-.2,1.4-.2,2c.1.7.1,1.3.2,2q.1,1.2.3,2.5t.6,2.6c.3.8.5,1.6,1,2.2s1.1,1,2.1.8c.8-.1,1.7-.4,2.5-.7s1.6-.6,2.4-.8c4.3-1.3,8.5-2.8,12.8-4.3c4.2-1.5,8.4-3,12.8-4.1c1.9-.5,3.8-.8,5.7-1.1s3.8-.4,5.7-.5c-1.2-1.4-2.4-3-3.6-4.5s-2.5-3-4-4.1c-1.3-.9-2.9-1.2-4.6-1.1-1.7,0-3.4.3-4.9.5-1.6.3-3.2.9-4.9,1.5-1.6.7-3.2,1.4-4.7,2q-2.4.9-4.7,1.8-2.4.8-4.8,1.5-1.2.4-2.5.7-1.2.3-2.5.5-.6.1-1.2.2-.7.1-1.3.2c-.4,0-.9.1-1.4.1-.4,0-.8.1-.8.1Z",
    fill: "url(#eLMG2cDahnp40-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.3,852q-.1.6-.2,1.2t-.3,1.2q-.3,1.5-.9,2.9-.7,1.4-1.7,2.6-.6.6-1.3,1.1t-1.5.9q-.3.2-.7.4-.3.1-.6.2-.9.4-1.9.7-.9.3-1.9.5-.5.1-1,.2-.4.1-1,.2-1.4.3-2.8.4-1.5.2-2.9.3-.7,0-1.4,0-.7-.1-1.5-.1-.9-.1-1.7-.2-.9-.2-1.7-.5-.4,0-.7-.1-.3-.2-.6-.3-1.5-.5-2.7-1.3-1.3-.8-2.4-1.8-.3-.4-.6-.7-.2-.3-.4-.6t-.3-.6-.2-.6q-.3-.9-.3-1.8t.3-1.8q0-.6.2-1.1t.4-1.1c.5-1.5,1.4-3,2.4-4.4c1.1-1.3,2.3-2.6,3.7-3.5q.6-.3,1.1-.6.5-.2,1-.5c2.4-1.2,4.9-2,7.5-2.4c2.7-.3,5.3-.3,7.9,0c1,.1,1.9.3,2.9.6.9.3,1.7.7,2.5,1.2q.2.2.4.3.1.2.3.4q1,1,1.6,2.2.6,1.3.8,2.6.2.9.3,1.9q0,1-.1,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.3,852q-.1.6-.2,1.2t-.3,1.2q-.3,0-.6.1-.4,0-.7,0c-3.4.1-6.8,0-10.1,0-3.4,0-6.7,0-10.1.4q-2.2.2-4.4.7-2.3.4-4.4,1.3-.6.2-1.1.5-.6.2-1,.6-.3-.9-.3-1.8t.3-1.8q0-.6.2-1.1t.4-1.1c.5-1.5,1.4-3,2.4-4.4c1.1-1.3,2.3-2.6,3.7-3.5q.6-.3,1.1-.6.5-.2,1-.5c3.4-1,6.9-1.6,10.4-1.8c3.5-.1,7,.3,10.4,1.2q.2.2.4.3.1.2.3.4q1,1,1.6,2.2.6,1.3.8,2.6.2.9.3,1.9q0,1-.1,2Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.1,848.1q-.3,0-.5.1-.3.1-.5.1-1,.2-2,.3t-2,.2c-3.1.2-6.2.2-9.2.4-3.1.1-6.2.3-9.2.9-1.1.2-2.3.4-3.4.8-1.1.3-2.2.7-3.2,1.2q-.6.3-1,.7-.5.3-1,.7-.2.2-.3.4-.2.2-.4.5q0-.6.2-1.1t.4-1.1c.5-1.5,1.4-3,2.4-4.4c1.1-1.3,2.3-2.6,3.7-3.5c2.6-1.6,5.4-2.7,8.4-3.3c3-.5,6.1-.6,9.1-.2c1.1.2,2.3.4,3.3.7c1.1.4,2,.9,2.8,1.8q1,1,1.6,2.2.6,1.3.8,2.6Z",
    fill: "url(#eLMG2cDahnp43-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1012,858.8q0,.8-.2,1.6-.1.8-.4,1.5-.3.2-.7.4-.3.1-.6.2c-.6.3-1.2.4-1.7.5-.6,0-1.1.1-1.7.2-.3.1-.8.2-1.2.2-.4.1-.8.1-1.1.2q-1.4.2-2.8.5-1.4.2-2.8.3c-.5,0-.9,0-1.3-.1-.5,0-.9,0-1.3,0-.7-.1-1.3-.1-2-.1s-1.4,0-1.9-.2q-.4,0-.7-.1-.3-.2-.6-.3-.8-1.1-1.1-2.3t-.3-2.5c0-2.9,1.2-5.4,3.2-7.3c2.1-1.9,4.9-3,8-3s5.9,1.1,7.9,3s3.3,4.4,3.3,7.3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.9,858.8q0,1-.2,1.9-.2,1-.6,1.8-.9.4-1.9.7-.9.3-1.9.5-.5.1-1,.2-.4.1-1,.2-1.4.3-2.8.4-1.5.2-2.9.3-.7,0-1.4,0-.7-.1-1.5-.1-.9-.1-1.7-.2-.9-.2-1.7-.5-.9-1.1-1.3-2.4-.5-1.4-.5-2.8q0-.9.2-1.7t.4-1.6c.8-1.8,2.1-3.3,3.8-4.4c1.6-1.1,3.7-1.7,5.9-1.7c1.9,0,3.8.5,5.3,1.4c1.6.9,2.9,2.2,3.7,3.7q.5,1,.8,2.1.3,1,.3,2.2Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.8,854.5c-2.4,0-4.9,0-7.3,0s-4.8.1-7.2.4q-1,.1-2.1.2-1,.2-2.1.4c.8-1.8,2.1-3.3,3.8-4.4c1.6-1.1,3.7-1.7,5.9-1.7c1.9,0,3.8.5,5.3,1.4c1.6.9,2.9,2.2,3.7,3.7Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.6,858.5c0,1.2-.4,2.3-.9,3.2-.6,1-1.4,1.8-2.4,2.4q-1.4.2-2.8.4-1.5.2-2.9.3c-1.4-.5-2.6-1.4-3.4-2.4-.8-1.1-1.3-2.5-1.3-3.9c0-1.8.8-3.4,2-4.6c1.3-1.2,3-1.9,4.9-1.9c1,0,2,.2,2.9.6.8.4,1.6,1,2.2,1.7q.5.6.9,1.2.3.6.5,1.3.1.4.2.8.1.5.1.9Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.6,855c-.2.3-.4.7-.4,1c0,.4.2.8.4,1.1.3.3.7.4,1.1.4s.8-.1,1.1-.4.4-.7.4-1.1c0-.3-.1-.7-.4-1s-.7-.5-1.1-.5-.8.2-1.1.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M984.3,854.4c.7-.7,1.6-1.1,2.6-1.5c1-.3,2-.6,3-.7q2.2-.4,4.4-.6q2.1-.2,4.3-.3q2.7-.2,5.3-.4q2.7-.1,5.3-.3q2,0,4.1-.2q2-.1,4-.4c1-.2,2.3-.9,3.3-1.8c1-1,1.7-2.2,1.5-3.3-1.2.5-3.6,1.1-6.5,1.5-2.9.5-6.2,1-9.3,1.2-2.5.2-5.6.3-8.6.5-2.9.2-5.7.6-7.4,1.3-1.4.6-2.5,1.3-3.4,2.1-1,.8-1.8,1.8-2.6,2.9Z",
    fill: "#020102"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M955.7,884.6q.5,0,.9.1t.8.3c3.2.8,6.5,1.3,9.8,1.3c3.3-.1,6.6-.5,9.8-1.2q.4-.1.9-.2.4-.1.8-.1.5,0,.9.1t.8.4q.1.1.1.2.1.1.1.2q0,.2,0,.3-.1.1-.2.2-.5.5-1.1.9-.6.3-1.3.6-1.2.5-2.5.9-1.4.4-2.7.6-1.8.4-3.7.7-1.8.3-3.7.3-1.9.1-3.8-.2-1.8-.2-3.6-.9-.7-.2-1.3-.6-.6-.3-1.2-.8c-.3-.3-.6-.6-.8-.9-.2-.4-.4-.8-.5-1.1-.1-.5.1-.7.4-.9.3-.1.8-.2,1.1-.2Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.3,892.8c-.5,1.2-1.5,1.8-2.7,2.2-1.1.4-2.4.6-3.5.7q-.8.1-1.6.2t-1.6.1-1.5.3q-.8.2-1.6.6t-1.7.7-1.9.3q-.9,0-1.8-.3t-1.8-.7q-.7-.4-1.5-.6-.8-.3-1.6-.3t-1.5-.1q-.8-.1-1.6-.2c-.5,0-1.1-.1-1.8-.2-.6-.1-1.2-.3-1.7-.5-.7-.3-1.2-.6-1.7-1s-.8-.8-1.1-1.2c-.7-.9-.6-1.9-.2-2.8.4-1,1.1-1.9,1.7-2.8.3-.4.5-.9.9-1.4.3-.4.8-.8,1.3-.9.4-.1.9,0,1.5.2.5.3,1,.5,1.4.7q2.1.8,4.2,1.3q2,.4,4.2.5c.2,0,.7,0,1.1,0c.5,0,.9,0,1.1,0q2.2-.1,4.3-.5q2.1-.5,4.1-1.3c.5-.2,1-.4,1.5-.7.5-.2,1-.3,1.5-.2s1,.5,1.4.9.7.9.9,1.3c.6.9,1.2,1.8,1.6,2.7.3,1,.3,2-.3,3Z",
    fill: "url(#eLMG2cDahnp53-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M952.2,887.2q-.3.3-.5.7-.3.3-.6.7-.2.3-.4.6t-.4.7c-.3.5-.2,1.1-.1,1.6.2.5.5.9.9,1.4q.6.7,1.3,1.2.6.5,1.5.9c0,0-.4-.3-.9-.8-.4-.5-1-1.1-1.3-1.5-.2-.2-.4-.6-.6-.9-.2-.4-.3-.8-.3-1.1q0-.4.2-.7t.4-.6q.5-.7.9-1.4.5-.7,1.1-1.4.2-.3.4-.7.2-.3.5-.7c.1-.2.3-.6.4-.9s.1-.5,0-.3q-.6.8-1.2,1.5-.6.8-1.3,1.7Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M982.3,887.2q.3.3.6.7.3.3.5.7.2.3.5.6.2.3.3.7c.3.5.3,1.1.1,1.6s-.5.9-.9,1.4q-.5.7-1.2,1.2t-1.5.9c0,0,.3-.3.8-.8s1-1.1,1.4-1.5c.1-.2.4-.6.6-.9.1-.4.3-.8.3-1.1q-.1-.4-.2-.7-.2-.3-.4-.6-.5-.7-1-1.4t-1-1.4q-.3-.3-.5-.7-.2-.3-.4-.7c-.2-.2-.3-.6-.4-.9s-.2-.5,0-.3q.5.8,1.1,1.5.6.8,1.3,1.7Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M971.6,896.5c0,0,.2-.1.4-.3s.5-.4.6-.6q.4-.3.8-.6t.7-.6c.5-.4,1.2-.8,1.8-1c.7-.3,1.5-.4,2.2-.5.2,0,.6,0,1,0c.3,0,.7.1.8.2.2.2.1.5,0,.7-.1.3-.3.5-.5.6-.4.4-1,.7-1.7.9-.8.2-1.5.4-2.1.5q-.5.1-1.1.2-.5.1-1,.2-.2,0-.4.1-.3,0-.5,0c-.1.1-.3.1-.5.1s-.4.1-.5.1Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.9,896.5c0,0-.2-.1-.4-.3-.3-.2-.5-.4-.7-.6q-.3-.3-.7-.6t-.8-.6c-.5-.4-1.1-.8-1.8-1-.7-.3-1.4-.4-2.2-.5-.2,0-.5,0-.9,0s-.7.1-.9.2c-.1.2-.1.5.1.7.1.3.3.5.4.6.4.4,1.1.7,1.8.9s1.5.4,2.1.5q.5.1,1,.2t1,.2q.3,0,.5.1.2,0,.4,0c.2.1.4.1.6.1s.3.1.5.1Z",
    fill: "#b22842"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M949.9,844.8c0,2-.1,4.5-.5,6.9-.5,2.4-1.2,4.7-2.5,6.5-2.5,3.5-6.6,4.8-11,4.8-4.4.1-9-1.1-12.4-2.5-3.3-1.4-6.1-4-8.5-7.1-2.3-3.1-4.2-6.8-5.6-10.4q-.1-3.8-.1-7.6-.1-3.7,0-7.5q0-1.8,0-3.6q0-1.9,0-3.7c1.4-1.2,3.1-1.8,4.9-2.2c1.9-.3,3.8-.3,5.6-.3c4.7.2,9.9,1,14.8,2.6c5,1.7,9.5,4.2,12.9,7.9.3.3.5.7.7,1s.4.6.5.8c.3,2.4.7,4.7.9,7.1.3,2.4.4,4.8.3,7.3Z",
    fill: "url(#eLMG2cDahnp62-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M914.8,850.7c.2,1.5.4,3,.9,4.5.5,1.4,1.3,2.8,2.3,3.9c1,1.2,2.3,2.1,3.8,2.7c1.5.7,3,1.1,4.5,1.5q2.5.6,5,.8q2.6.3,5.2.2q2.8-.2,5.3-1.4q2.4-1.1,4.4-3.2.3-.3.6-.6.2-.4.4-.7.7-1.2.8-2.5t-.2-2.6q-.1-.6-.3-1.2t-.4-1.1c-.5-1.6-1.4-3.3-2.4-4.7-1.1-1.5-2.3-2.8-3.7-3.8-2.5-1.7-5.4-2.9-8.4-3.5s-6.1-.6-9.1-.2c-1.1.2-2.3.4-3.3.8-1.1.4-2,.9-2.8,1.8q-.9,1.1-1.5,2.4t-.9,2.7q-.2,1.1-.2,2.1-.1,1.1,0,2.1Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.9,822.1c.2.8.2,1.5.2,2.1c0,.7-.1,1.3-.2,1.9q-.1,1.3-.3,2.6t-.6,2.5c-.2.9-.5,1.7-1,2.3s-1.1,1-2.1.8c-.8-.1-1.6-.4-2.5-.7-.8-.3-1.6-.6-2.4-.8-4.3-1.3-8.5-2.8-12.7-4.4-4.3-1.5-8.5-2.9-12.9-4-1.9-.5-3.8-.9-5.7-1.1-1.8-.3-3.7-.5-5.7-.6c1.2-1.3,2.4-2.9,3.6-4.4c1.2-1.6,2.5-3,4-4.1c1.3-.9,3-1.2,4.6-1.2c1.7,0,3.4.3,4.9.6c1.6.3,3.2.8,4.9,1.5c1.6.6,3.2,1.3,4.7,2q2.4.9,4.8,1.7q2.3.9,4.7,1.6q1.3.3,2.5.6t2.5.6q.6.1,1.2.2.7.1,1.3.2c.4,0,.9.1,1.4.1s.8,0,.8,0Z",
    fill: "url(#eLMG2cDahnp64-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.8,852.5q.1.6.2,1.2t.3,1.2q.3,1.5,1,2.9.6,1.4,1.7,2.6.5.6,1.2,1.1.8.5,1.5.9.4.2.7.3.3.2.6.3q1,.4,1.9.7q1,.3,1.9.5.5.1,1,.2t1,.2q1.4.2,2.8.4q1.5.2,2.9.2.7,0,1.4,0q.8,0,1.5,0q.9-.1,1.7-.3.9-.1,1.7-.4.4,0,.7-.2.3-.1.7-.3q1.4-.5,2.6-1.3q1.3-.8,2.4-1.8.3-.3.6-.6.2-.3.4-.7.2-.3.3-.6t.3-.6q.2-.8.2-1.7t-.2-1.8q-.1-.6-.3-1.1-.2-.6-.4-1.1c-.5-1.5-1.4-3-2.4-4.4-1.1-1.4-2.3-2.6-3.7-3.5q-.5-.3-1.1-.6-.5-.3-1-.5c-2.4-1.2-4.9-2-7.5-2.4s-5.3-.4-7.9,0c-.9.1-1.9.3-2.8.5-1,.3-1.8.7-2.6,1.3q-.2.1-.3.3-.2.2-.4.4-.9,1-1.5,2.2t-.9,2.5q-.2,1-.2,2-.1,1,0,2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.8,852.5q.1.6.2,1.2t.3,1.2q.3,0,.7,0q.3,0,.7,0c3.3.2,6.7.1,10,.1c3.4,0,6.8,0,10.1.3q2.2.3,4.5.7q2.2.5,4.3,1.3.6.3,1.1.5.6.3,1.1.6.2-.8.2-1.7t-.2-1.8q-.1-.6-.3-1.1-.2-.6-.4-1.1c-.5-1.5-1.4-3-2.4-4.4-1.1-1.4-2.3-2.6-3.7-3.5q-.5-.3-1.1-.6-.5-.3-1-.5c-3.4-1.1-6.8-1.7-10.4-1.8-3.5-.1-7,.3-10.4,1.2q-.2.1-.3.3-.2.2-.4.4-.9,1-1.5,2.2t-.9,2.5q-.2,1-.2,2-.1,1,0,2Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915,848.5q.3.1.5.2.3,0,.5.1q1,.2,2,.3t2,.2c3.1.2,6.2.2,9.2.3c3.1.2,6.2.4,9.2.9c1.1.2,2.3.5,3.4.8c1.2.4,2.3.8,3.3,1.3q.5.3.9.6.5.4,1,.8.2.2.4.4t.4.5q-.1-.6-.3-1.1-.2-.6-.4-1.1c-.5-1.5-1.4-3-2.4-4.4-1.1-1.4-2.3-2.6-3.7-3.5-2.5-1.6-5.4-2.7-8.4-3.3s-6.1-.6-9.1-.2c-1.1.1-2.3.3-3.3.7-1.1.4-2,.9-2.8,1.8q-.9,1-1.5,2.2t-.9,2.5Z",
    fill: "url(#eLMG2cDahnp67-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M920.1,859.2q0,.9.2,1.7.1.7.4,1.5.4.2.7.3.3.2.6.3c.6.3,1.2.4,1.7.4.6.1,1.1.1,1.7.3.4.1.8.1,1.2.2.4,0,.8.1,1.1.2q1.5.2,2.8.4q1.4.3,2.9.4c.4,0,.8-.1,1.3-.1.4,0,.8,0,1.3-.1.6,0,1.3,0,1.9,0c.7,0,1.4,0,1.9-.2q.4,0,.7-.2.3-.1.7-.3.7-1,1-2.2t.3-2.6c0-2.8-1.2-5.4-3.2-7.2-2-1.9-4.8-3.1-8-3.1-3,0-5.9,1.2-7.9,3.1-2,1.8-3.3,4.4-3.3,7.2Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.2,859.2q0,1.1.2,2q.2,1,.6,1.8q1,.4,1.9.7q1,.3,1.9.5.5.1,1,.2t1,.2q1.4.2,2.8.4q1.5.2,2.9.2.7,0,1.4,0q.8,0,1.5,0q.9-.1,1.7-.3.9-.1,1.7-.4.9-1.1,1.3-2.5.5-1.3.5-2.8q0-.8-.2-1.6t-.4-1.6c-.8-1.8-2.1-3.4-3.7-4.4-1.7-1.1-3.7-1.8-6-1.8-1.9,0-3.8.5-5.3,1.5-1.6.9-2.9,2.2-3.7,3.7q-.5,1-.8,2-.3,1.1-.3,2.2Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.3,855c2.4,0,4.9,0,7.3,0s4.8.1,7.2.3q1,.1,2.1.3q1,.1,2.1.4c-.8-1.8-2.1-3.4-3.7-4.4-1.7-1.1-3.7-1.8-6-1.8-1.9,0-3.8.5-5.3,1.5-1.6.9-2.9,2.2-3.7,3.7Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.6,859c0,1.2.3,2.3.8,3.2.6,1,1.4,1.8,2.4,2.4q1.4.2,2.8.4q1.5.2,2.9.2c1.4-.4,2.6-1.3,3.4-2.4s1.3-2.4,1.3-3.8c0-1.8-.8-3.4-2-4.6s-3-1.9-4.9-1.9c-1,0-2,.2-2.9.6-.8.4-1.6,1-2.2,1.7q-.5.6-.8,1.2-.4.6-.6,1.3-.1.4-.2.8q0,.4,0,.9Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.3,854.9c.3.3.4.7.4,1.1s-.1.7-.4,1-.7.5-1,.5c-.4,0-.8-.2-1.1-.5s-.4-.6-.4-1c-.1-.4.1-.8.4-1.1s.7-.4,1-.4c.4,0,.8.1,1.1.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M947.8,854.9c-.7-.7-1.6-1.2-2.6-1.5-.9-.4-2-.6-3-.8q-2.2-.3-4.3-.6-2.2-.2-4.4-.3-2.7-.1-5.3-.3-2.7-.2-5.3-.3-2-.1-4.1-.2-2-.1-4-.4c-1-.2-2.2-.9-3.2-1.9-1-.9-1.8-2.1-1.6-3.2c1.2.5,3.6,1,6.5,1.5s6.2.9,9.3,1.2c2.5.2,5.6.3,8.6.5c2.9.2,5.7.5,7.4,1.3c1.4.6,2.5,1.3,3.4,2.1c1,.8,1.8,1.7,2.6,2.9Z",
    fill: "#020102"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1037.8,988.6c-2.8,7.3-6.9,13.8-11.9,19.4-5.1,5.6-11.1,10.5-17.8,14.5-10.1,6.1-21.8,9.3-32.8,10.5-11.1,1.3-21.5.6-29.1-1-4.6-1-9.4-2.4-14-4.3-4.5-2-8.9-4.3-12.7-7-3-2.1-5.8-4.5-8.2-6.9s-4.4-4.8-5.8-6.7c-1-1.5-2.5-3.7-3.8-6-1.4-2.2-2.7-4.6-3.3-6.3-.1-.4-.9-2.5-1.6-4.5s-1.4-4-1.2-4.1q2.3-1.8,4.7-3q2.3-1.3,4.4-2c1.5-.6,3.1-1.2,4.8-1.8s3.5-1,5.2-1.3c.4,2.8,1.3,5.5,2.4,8.1c1.1,2.5,2.5,4.9,4.2,7.1.9,2.4,2,4.7,3.3,6.9s2.7,4.2,4.3,6c4.3,4.9,9.6,8.4,15.5,10.9s12.3,4,18.5,4.7c5.5.5,11.1.4,16.6-.3s11-1.9,16.3-3.4c2.6-.8,5.2-1.7,7.8-2.7s5.1-2.1,7.5-3.3c2-1,4.3-2.1,6.4-3.4c2.2-1.3,4.3-2.7,6-4.2q3.1-2.9,5.9-6.1q2.7-3.3,5-6.8q1.2-1.9,2.3-3.7q1.1-1.9,2.2-3.7q0,0,0,.1t0,.2c.2.5,0,1.2-.3,2s-.6,1.6-.8,2.1Z",
    fill: "url(#eLMG2cDahnp75-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.9,1009.9c5.5-3,11-6.3,16.1-10.2c5-3.8,9.6-8.2,13.2-13.4.5-.7,1-1.4,1.6-2c.5-.7,1.1-1.4,1.6-2.1q.3-.5.6-.9.4-.5.8-1q.4-.4.9-.8.6-.3,1.2-.5.7-.1,1.4,0t1.3.3q.8.2,1.4.5.7.3,1.2.8c.4.4.7,1,.8,1.6.2.5.2,1.2.2,1.8-.1,2.3-.9,4.5-2,6.5-1.1,2.1-2.6,4-4.1,5.9-3.2,4-7.1,7.4-11.4,10.2-4.3,2.7-9,4.9-13.8,6.7q-3.6,1.2-7.4,2.2-3.7,1-7.5,1.7c-1.6.3-5.1.5-8.2.6s-5.8.1-5.8.1s1.5-.4,3-1c1.6-.5,3.4-1.1,3.9-1.4q2.7-1.2,5.3-2.5q2.7-1.4,5.3-2.8.1-.1.2-.2.1,0,.2-.1Z",
    fill: "url(#eLMG2cDahnp76-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.9,991.5c1.9-.8,3.1-2.9,4.2-4.9c1.2-1.9,2.4-3.8,4.3-4.1c1.4-.3,1.7.6,1.7,1.7s-.5,2.4-.7,3c-.5,1-1.2,2.2-2.1,3.2-.8,1.1-1.9,2-3,2.6-1.5.9-2.8.8-3.6.4s-1.2-1.2-.8-1.9Z",
    fill: "#ffd2ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eLMG2cDahnp78",
    transform: "translate(0-1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809.6,1165.5l4.2-3.6l4.1-3.7l149.4-2.3l149.3-2.3l4.2,4l4.1,4-157.6,2-157.7,1.9Z",
    fill: "url(#eLMG2cDahnp79-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.9,1161.7l-11.4,68.6-11.3,68.6-2.2,13.4-2.2,13.3h-129.6-129.6l-14.5-80-14.5-80l3.1-.1h3l154.6-1.9l154.6-1.9Z",
    fill: "url(#eLMG2cDahnp80-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.6,1253.7c0-7-3.1-13.4-8.1-18s-12-7.4-19.7-7.4-14.6,2.8-19.6,7.4c-5.1,4.6-8.2,11-8.2,18s3.1,13.4,8.2,18c5,4.6,11.9,7.5,19.6,7.5s14.7-2.9,19.7-7.5s8.1-11,8.1-18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.2,1251.4c0-7-3.1-13.4-8.1-18-5.1-4.6-12-7.4-19.7-7.4s-14.7,2.8-19.7,7.4-8.1,11-8.1,18s3.1,13.4,8.1,18s12,7.5,19.7,7.5s14.6-2.9,19.7-7.5c5-4.6,8.1-11,8.1-18Z",
    fill: "url(#eLMG2cDahnp82-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.2,1298.9l-2.2,13.4-2.2,13.3h-129.6-129.6l-14.5-80-14.5-80l3.1-.1h3c.5,1,1,2,1.5,2.9.4,1,.9,1.9,1.2,2.8c1.7,4.2,3.7,8.2,5.9,12.2c2.2,3.9,4.7,7.8,7.1,11.6q9.7,15.2,21.5,28.6t25.6,24.9c24.5,20.6,54,33.7,85.2,41.7c31.1,8,64,10.9,95.1,10.7q10.9-.1,21.8-.6q10.8-.5,21.6-1.4Z",
    fill: "url(#eLMG2cDahnp83-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 62.6945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eLMG2cDahnp85",
    transform: "translate(0-1289.099792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.4,1327.9q-.7,5.5-1.8,10.9t-2.6,10.7q-1.4,4.9-3.2,9.7t-4.1,9.4q-2.2,4.3-4.8,8.2-2.7,4-5.9,7.5-3.1,3.5-6.8,6.5-3.6,2.9-7.7,5.1c-3.1,1.8-6.4,3.2-9.8,4.3s-7,1.8-10.5,2.1c-4.3.3-8.5.1-12.7-.6-4.2-.6-8.4-1.7-12.3-3.2-3.2-1.2-6.2-2.7-9.1-4.3-2.9-1.7-5.7-3.6-8.4-5.6q-4-3.2-7.6-6.8-3.6-3.7-6.7-7.8-3.3-4.2-6-8.9t-4.8-9.6q-2.2-5.3-3.7-10.7-1.5-5.5-2.3-11.1-.2-1.3-.4-2.7t-.3-2.8c0-.4-.2-.7-.4-1-.3-.2-.6-.4-1-.4s-.7.2-1,.4c-.3.3-.4.6-.4,1q.5,5.9,1.7,11.7t3.2,11.4q1.9,5.3,4.3,10.3q2.5,5,5.6,9.7q3,4.5,6.5,8.5q3.6,4.1,7.6,7.7q3.9,3.4,8.2,6.3t9,5.2c3.8,1.8,7.8,3.2,11.9,4.3c4.1,1,8.3,1.7,12.5,1.9q3.3.1,6.6-.1q3.3-.3,6.5-.9q2.7-.6,5.3-1.5t5.1-2q4.5-1.9,8.6-4.6t7.7-6.1t6.6-7.2q3.1-3.9,5.5-8.1q2.7-4.5,4.8-9.3t3.7-9.8q1.8-5.2,3.1-10.6q1.2-5.3,2.2-10.8.2-1.4.4-2.8.3-1.4.5-2.8c0-.3,0-.7-.2-1-.1-.3-.4-.6-.8-.7-.3-.1-.8,0-1.1.1-.3.2-.6.5-.7.9Z",
    opacity: 0.7,
    fill: "url(#eLMG2cDahnp86-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.5,1328.4q-2.3,9.1-5.2,18t-6.5,17.5q-3.5,8.5-7.6,16.6-4.2,8.2-9,16-4.8,7.5-10.2,14.7-5.4,7.1-11.6,13.6c-4.1,4.3-8.5,8.4-13.3,12-4.8,3.7-9.9,6.8-15.5,9.2-4.7,2-9.8,3.4-14.9,4.1-5.2.7-10.4.7-15.5.2-5-.5-10-1.6-14.8-3.1-4.8-1.6-9.4-3.6-13.9-5.9-4.7-2.5-9.2-5.4-13.6-8.6-4.3-3.2-8.4-6.6-12.3-10.3q-6.1-5.9-11.6-12.4t-10.3-13.6q-4.7-7.1-8.8-14.5-4.1-7.5-7.4-15.4-1.9-4.5-3.5-9-1.6-4.6-3-9.2-1.3-4.1-2.3-8.3-.9-4.2-1.7-8.5-.1-.6-.1-1.1-.1-.6-.2-1.2-.1-.2-.1-.4t-.1-.4c0-.2,0-.2,0-.1c0,0,0,.1,0-.1q-.4.4-.9.7-.4.4-.9.7q0,0,0,0t0,0q-.2-.2-.4-.3-.2-.2-.4-.4c-.1-.3-.2-.2-.1-.1c0,.1.1.3.1.4.2.9,1,1.1,1.7.9.6-.1,1.2-.8,1-1.7-.1-.3-.2-.6-.3-.9-.2-.3-.4-.5-.8-.6-.5-.2-.9,0-1.2.2-.4.3-.6.7-.6,1.1q0,.4,0,.8.1.4.2.7.1.6.2,1.2t.2,1.2q.3,1.7.6,3.3.3,1.7.6,3.4c.7,3.5,1.7,7,2.7,10.4c1.1,3.4,2.3,6.8,3.5,10.1q3,8.3,6.8,16.2t8.4,15.4q4.5,7.5,9.8,14.4q5.2,7,11.2,13.3c3.8,4.1,7.9,7.9,12.2,11.5s8.8,6.9,13.5,9.9c4.4,2.8,9.1,5.2,13.9,7.2c4.9,2.1,9.9,3.7,15,4.7c5,1.1,10.2,1.6,15.4,1.6c5.1-.1,10.3-.7,15.3-2c5.8-1.5,11.3-3.9,16.5-6.9c5.1-3.1,9.9-6.8,14.4-10.7c4.6-4.1,8.8-8.6,12.8-13.2c4.1-4.7,7.8-9.6,11.3-14.7q5.3-7.6,9.9-15.6q4.5-8.1,8.4-16.5q4-8.7,7.3-17.6t5.9-18.1q.7-2.2,1.3-4.5.6-2.2,1.2-4.5c.2-.9-.4-1.5-1.1-1.7-.6-.2-1.4.1-1.6.9Z",
    opacity: 0.7,
    fill: "url(#eLMG2cDahnp87-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497,1332.3h-518.4-518.3v-3.8-3.8h518.3h518.4v3.8v3.8Z",
    fill: "url(#eLMG2cDahnp88-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eLMG2cDahnp89",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1185.9,1362.1h111.3h111.2c2,0,3.7.8,5,2.1c1.3,1.2,2.1,3,2.1,5v20.9v21c0,2-.8,3.8-2.1,5-1.3,1.3-3,2.1-5,2.1h-111.2-111.3c-2,0-3.7-.8-5-2.1-1.3-1.2-2.1-3-2.1-5v-21-20.9c0-2,.8-3.8,2.1-5c1.3-1.3,3-2.1,5-2.1Z",
    fill: "url(#eLMG2cDahnp90-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1363.3,1392c0,4,1.6,7.6,4.3,10.2c2.6,2.6,6.2,4.2,10.2,4.2s7.6-1.6,10.2-4.2s4.3-6.2,4.3-10.2-1.7-7.6-4.3-10.2c-2.6-2.7-6.2-4.3-10.2-4.3s-7.6,1.6-10.2,4.3c-2.7,2.6-4.3,6.2-4.3,10.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.3,1392c0,4,1.6,7.6,4.2,10.2c2.7,2.6,6.3,4.2,10.3,4.2s7.6-1.6,10.2-4.2s4.2-6.2,4.2-10.2-1.6-7.6-4.2-10.2c-2.6-2.7-6.2-4.3-10.2-4.3s-7.6,1.6-10.3,4.3c-2.6,2.6-4.2,6.2-4.2,10.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.5,1392c0,4,1.6,7.6,4.2,10.2s6.2,4.2,10.2,4.2s7.6-1.6,10.3-4.2c2.6-2.6,4.2-6.2,4.2-10.2s-1.6-7.6-4.2-10.2c-2.7-2.7-6.3-4.3-10.3-4.3s-7.6,1.6-10.2,4.3c-2.6,2.6-4.2,6.2-4.2,10.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204,1392c0,4,1.6,7.6,4.2,10.2s6.3,4.2,10.3,4.2s7.6-1.6,10.2-4.2s4.2-6.2,4.2-10.2-1.6-7.6-4.2-10.2c-2.6-2.7-6.2-4.3-10.2-4.3s-7.7,1.6-10.3,4.3c-2.6,2.6-4.2,6.2-4.2,10.2Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eLMG2cDahnp96",
    transform: "translate(0-1309.749878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.9,1323.7q0,1.1-.1,2.3q0,1.1-.2,2.2h-32.1-32.1q-.1-1.1-.2-2.2-.1-1.2-.1-2.3c0-9,3.6-17,9.5-22.9s14-9.5,22.9-9.5c9,0,17.1,3.6,22.9,9.5c5.9,5.9,9.5,13.9,9.5,22.9Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M771.3,1291.4q0,3.5,0,7.1t0,7.2c0,.5-.4.8-.8.8-.5,0-.9-.3-.9-.8v-3.4-3.4q-.1-1.9-.1-3.8t0-3.8q.5,0,.9,0t.9.1Z",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork50);
export default __webpack_public_path__ + "static/media/work50.b6f5a4951d224bbba0787406c42da507.svg";
export { ForwardRef as ReactComponent };